export default class KeuzeConfetti {
    constructor({
        element,
        destroyCanvas = false,
        confettiPieces = 100,
        duration = 3500,
    }) {
        this.element = element;
        this.canvas = null;
        this.ctx = null;
        this.confetti = [];
        this.stop = false;
        this.destroyCanvas = destroyCanvas;
        this.confettiPieces = confettiPieces;
        this.duration = duration;

        // Array of SVG paths for confetti pieces
        /* eslint-disable */
        this.svgPaths = [
            '<svg width="24" height="24" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.95083 4.56863C0.234183 2.66471 -0.0809131 1.03371 1.16372 0.853997C3.2567 0.556519 6.72381 4.11213 8.04551 6.50296C8.66162 7.62089 8.43537 8.45091 7.52398 8.34273C6.09159 8.16933 3.81272 6.63365 1.95083 4.56863Z" fill="#FFA600"/></svg>',
            '<svg width="24" height="24" viewBox="0 0 30 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.1175 4.72543C28.1175 4.72543 25.0093 2.58275 16.203 2.58275C7.39659 2.58275 2.16393 6.82314 1.76311 7.13321C1.12723 7.66578 0.144287 7.14978 0.727062 6.29176C1.05083 5.82192 5.58352 0.524099 16.203 0.524099C26.1101 0.524099 29.1121 3.47864 29.4125 3.768C30.2543 4.54791 29.3478 5.43552 28.1175 4.72543Z" fill="#FFDBE4"/></svg>',
            '<svg width="24" height="24" viewBox="0 0 11 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26343 2.11134C9.67003 3.17741 10.8447 4.21443 9.9922 4.46573C8.55584 4.88521 3.86096 2.92228 1.47901 1.49425C0.366701 0.826307 0.0656323 0.25716 0.827055 0.230556C2.02569 0.190969 4.65321 0.955063 7.26343 2.11134Z" fill="#F66C1E"/></svg>',
            '<svg width="24" height="24" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6079 7.37258C11.8623 6.47207 8.22501 5.08649 6.71685 4.77405C5.74402 4.50918 4.79555 4.43703 4.48779 4.3832C4.18003 4.32937 2.1037 4.07796 1.11407 4.08279C0.202795 4.08642 -0.375427 2.49216 0.754812 2.15649C1.88505 1.82082 6.26506 0.447542 8.84551 0.182319C9.80197 0.083788 10.3729 1.36167 9.48238 1.63313C8.69478 1.8729 7.92663 2.12135 5.98711 2.63563C8.93838 3.15659 11.8062 3.88532 14.4916 5.49094C16.2197 6.5213 15.3335 8.25951 13.6079 7.37258Z" fill="#F6829F"/></svg>',
            '<svg width="24" height="24" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.55115 0C2.46108 0 0 2.68154 0 5.01692C0 7.35231 2.58626 9 5.67328 9C8.7603 9 12 6.31846 12 3.98538C12 1.65231 8.63817 0 5.55115 0Z" fill="#89D7E4"/></svg>',
            '<svg width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.7559 4.81733C19.3367 6.81814 13.1216 11.5063 11.0303 13.7271C9.56391 15.0927 8.47913 16.6208 8.07077 17.0845C7.66241 17.5482 5.11445 20.7945 4.13105 22.4735C3.224 24.0188 -0.310354 23.312 0.20091 21.0455C0.712174 18.779 2.55919 9.91912 4.6552 5.27409C5.43168 3.55214 8.3724 3.93691 7.98252 5.73005C7.63712 7.31563 7.32729 8.87749 6.33552 12.7016C10.2604 8.26018 14.4866 4.17944 20.155 1.33399C23.7973 -0.500179 26.13 2.83572 22.7559 4.81733Z" fill="#5CC787"/></svg>',
        ];
        /* eslint-eneable */

        this.confettiImages = []; // Array to store pre-rendered confetti images

        this.createCanvas();
        this.createConfettiImages();
        this.startAnimation();

        setTimeout(() => {
            this.stopAnimation();
        }, this.duration);
    }

    createCanvas() {
        this.canvas = document.createElement('canvas');
        this.canvas.style.position = 'fixed';
        this.canvas.style.zIndex = 200;
        this.canvas.style.pointerEvents = 'none';
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.ctx = this.canvas.getContext('2d');
        document.body.appendChild(this.canvas);
    }

    createConfettiImages() {
        for (let i = 0; i < this.svgPaths.length; i++) {
            const svgPath = this.svgPaths[i];
            const svg = new DOMParser().parseFromString(svgPath, 'image/svg+xml')
                .querySelector('svg');
            svg.setAttribute('width', '24');
            svg.setAttribute('height', '24');

            const svgData = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
            this.confettiImages.push(img);
        }
    }

    startAnimation() {
        this.confetti = [];

        for (let i = 0; i < this.confettiPieces; i++) {
            const size = Math.random() * 20 + 10;
            const x = Math.random() * this.canvas.width;
            const y = Math.random() * -this.canvas.height;

            const confettiPiece = {
                x,
                y,
                size,
                rotation: Math.random() * 360,
                speedX: Math.random() * 4 - 2,
                speedY: Math.random() * 5 + 4,
                image: this.confettiImages[Math.floor(Math.random() * this.confettiImages.length)],
            };

            this.confetti.push(confettiPiece);
        }

        this.animate();
    }

    stopAnimation() {
        this.stop = true;
    }

    finish() {
        if (this.destroyCanvas) {
            this.canvas.remove();
        }
    }

    animate() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        for (let i = 0; i < this.confetti.length; i++) {
            const confettiPiece = this.confetti[i];

            this.ctx.save();
            this.ctx.translate(confettiPiece.x, confettiPiece.y);
            this.ctx.rotate((confettiPiece.rotation * Math.PI) / 180);

            this.ctx.drawImage(
                confettiPiece.image,
                -confettiPiece.size / 2,
                -confettiPiece.size / 2,
                confettiPiece.size,
                confettiPiece.size,
            );

            this.ctx.restore();

            confettiPiece.y += confettiPiece.speedY;
            confettiPiece.x += confettiPiece.speedX;

            if (confettiPiece.y > this.canvas.height) {
                if (this.stop) {
                    this.confetti.splice(i, 1);
                } else {
                    confettiPiece.y = Math.random() * -this.canvas.height;
                }
            }
        }

        if (this.confetti.length === 0) {
            this.finish();
        } else {
            requestAnimationFrame(() => this.animate());
        }
    }
}

// Usage:
// const element = document.getElementById('myElement'); // Replace 'myElement' with the ID of your DOM element
// const confettiAnimation = new KeuzeConfetti(element);
